import { z } from 'zod';

const thirdPartyResolutionFormSchema = (requireNotes: boolean) => z.discriminatedUnion('isVideoRequired', [
    z.object({
        isVideoRequired: z.literal(true),
        selectedProblemRegisterIds: z.array(z.number()),
        documents: z.array(z.object({
            id: z.string(),
            name: z.string(),
            size: z.number(),
            type: z.string(),
            isValid: z.boolean(),
        })).min(1, 'Please upload at least one document.'),
        notes: z.string().max(500, 'Message should be 500 characters or less').optional(),
    }),
    z.object({
        isVideoRequired: z.literal(false),
        selectedProblemRegisterIds: z.array(z.number()),
        documents: z.array(z.object({
            id: z.string(),
            name: z.string(),
            size: z.number(),
            type: z.string(),
            isValid: z.boolean(),
        })).min(1, 'Please upload at least one document.'),
        notes: z.string().max(500, 'Message should be 500 characters or less').optional(),
    }),
]).superRefine((data, ctx) => {
    if (data.documents.length === 0) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'At least one supporting document is required.',
            path: ['documents'],
        });

        return;
    }

    if (data.documents.some((d) => !d.isValid)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'One or more documents are invalid. Please remove them to continue.',
            path: ['documents'],
        });
    }

    if (data.isVideoRequired) {
        // Check that at least one of the file types is 'video'
        if (data.documents.every((file) => file.type !== 'video')) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'At least one video file is required.',
                path: ['documents'],
            });
        }
    }

    if (requireNotes) {
        if (data.notes === undefined || data.notes.trim().length === 0) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Notes are required for this resolution.',
            });
        }
    }
});

type EditThirdPartyResolutionFormSchema = z.infer<
ReturnType<typeof thirdPartyResolutionFormSchema>>;

export {
    EditThirdPartyResolutionFormSchema,
    thirdPartyResolutionFormSchema,
};
